const params = {
    jobStatus: {
        "draft": '下書き',
        "closed": '募集終了',
        "open": '公開中',
    },
    path: {
        uploadFile: '/api/chat/upload/file',
        authToken: '/api/chat/token',
        init: '/api/chat/init',
        room: '/api/chat/room',
        unreadStatus: '/api/chat/unread-status',
    }
}

export default params;